module.exports = __webpack_public_path__ + "assets/img/fish-hit.c9e61849.png";